import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { AcmTypehasReason } from '../../models/loyalty-acm-type.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class AcmTypeHasReasonService {

  public baseUrl = '/koncentro-loyalty/acm';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService
  ) { }

  getFromAcmType(acmTypeId, search?): Observable<{data: Array<AcmTypehasReason>, metadata: ListMetadata}> {

    const params: URLSearchParams = new URLSearchParams();
    if(acmTypeId)
      params.set('acm_type_id', acmTypeId);
    if ( search ) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }

    return this.http.getPaged(this.baseUrl + '/acm_type/getReasons?' + params.toString());
  }
  /*
  getFromAcmTypeRole(acmTypeId,roleId): Observable<{data: Array<AcmTypehasReason>, metadata: ListMetadata}> {
    return this.http.getPaged(this.baseUrl + '/acm_type/getReasons?acm_type_id=' + acmTypeId + "&role_id="+roleId);
  }
  */

  getFromRoleId(acmTypeId, roleId): Observable<{data: Array<AcmTypehasReason>, metadata: ListMetadata}> {
    return this.http.getPaged(this.baseUrl + '/acm_type/' + acmTypeId + '/reason?role=' + roleId);
  }

  getFromRoleIdandAcmTypeId(acmTypeId, reasonId, roleId): Observable<{data: Array<AcmTypehasReason>, metadata: ListMetadata}> {
    return this.http.get(this.baseUrl + '/acm_type/' + acmTypeId + '/reason/' + reasonId + '/role/' + roleId);
  }

  create(acmTypeHasReason: AcmTypehasReason) {
    return this.http.post(this.baseUrl + '/acm_type/reason/', acmTypeHasReason);
  }

  update(acm_type_id, reason_id, grant_role_id, acmTypeHasReason: AcmTypehasReason) {
    return this.http.put(this.baseUrl + '/acm_type/' + acm_type_id + '/reason/' + reason_id + '/role/' + grant_role_id, acmTypeHasReason);
  }

  remove(acm_type_id, reason_id, grant_role_id) {
    return this.http.delete(this.baseUrl + '/acm_type/' + acm_type_id + '/reason/' + reason_id + '/role/' + grant_role_id);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get('koncentro-loyalty/schema/ReasonAcmTypeDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/acm-type-has-reason.service.ts